import {Component, inject} from '@angular/core';
import {EventsManager} from '../../../events/events.manager';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false
})

export class LoadingComponent {
  public eventsManager: EventsManager = inject(EventsManager);
}
